import React from 'react';

import { Link } from "react-router-dom";
import { emojiList } from 'components/EmojiSelector';
import { formatDate } from 'utils/formatDate';
import { IResposta } from './Dashboard';


interface IColunaTabela {
  row: {
    original: IResposta
  };
}

export function ColunaVerbalizacao({ row }: IColunaTabela) {
  const resposta = row?.original ?? null;
  const verbalizacao = resposta?.observacao ? resposta.observacao : null;

  return (
    <Link to="#" className="text-body">
      <span className="ms-2">
        {verbalizacao || '-'}
      </span>
    </Link>
  );
};

export function ColunaData({ row }: IColunaTabela) {
  const resposta = row?.original ?? null;

  return (
    <Link to="#" className="text-body">
      <span className="ms-2">
        {
          resposta.created_at
            ?
            formatDate(resposta.created_at)
            :
            '-'
        }
      </span>
    </Link>
  );
};
